// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var ChevronRight = function ChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.305 17.7c-.354-.392-.44-1.035.005-1.478L12.543 10 6.306 3.777a1.05 1.05 0 0 1 0-1.468c.344-.344.944-.473 1.48 0l6.977 6.94c.41.356.43 1.087 0 1.481L7.787 17.7c-.405.407-1.086.386-1.482 0"
  }));
};
